import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import Nav from "./nav"
import MobileNav from "./mobileNav"
import MobileMenu from "./mobileMenu"


class Header extends React.Component {

  state = {
    open: false,
  }

  toggleMenu = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  }

  render() {
    const { open } = this.state;
    return (
      <>
        <StyledHeader>
          <div className="bar">
            <Logo>
              <Link to="/">
                Trendymoscow
              </Link>
            </Logo>
            <Nav />
            <MobileNav toggleMenu={this.toggleMenu} />
          </div>
        </StyledHeader>
        { open ? <MobileMenu /> : null }
      </>
    )
  }

}


const Logo = styled.div`
  font-size: 2rem;
  margin: 1rem 0 1rem 2rem;
  position: relative;
  z-index: 2;
  transform: skew(-7deg);
  @media (max-width: 800px) {
    transform: skew(-3deg);
  }
  a {
    padding: 0.5rem 1rem;
    background: ${props => props.theme.red};
    color: white;
    text-transform: uppercase;
    text-decoration: none;
  }
  @media (max-width: 1300px) {
    text-align: center;
    font-size: 2rem;
  }
  @media (max-width: 800px) {
    margin: 0.5rem 0 0.5rem 1rem;
  }
`;

const StyledHeader = styled.header`
  .bar {
    position: relative;
    border-bottom: 10px solid ${props => props.theme.black};
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    @media (max-width: 1160px) {
      align-items: center;
    }
  }
`;


export default Header
